import { connect } from 'react-redux';
import Component from './StreamVoDRoot';
import { setHeaderTitle } from '../../../../actions/layout';
import { listStateFromCRUD } from '../../../../selectors/crud';
import { videoCategoriesActions } from '../../../../actions/video-categories'
import {getListActions} from '../../../../utilites/helpers/crudListHelper';

import { replace } from 'react-router-redux/lib/actions';

export default connect(
  (state) => ({
    categories_state: listStateFromCRUD(state.video_categories),
  }),
  dispatch => {
    return {
      categories_actions: getListActions(videoCategoriesActions, dispatch),
      updateHeaderTitle: title => dispatch(setHeaderTitle(title)),
      switchTab: (tab) => dispatch(replace({pathname: '/stream/vod/category/' + tab})),
    };
  },
)(Component);



// WEBPACK FOOTER //
// ./src/components/Stream/CustomStream/StreamVoDRoot/index.js